import { render, staticRenderFns } from "./oldTreeMsg.vue?vue&type=template&id=17eeaf1a&"
import script from "./oldTreeMsg.vue?vue&type=script&lang=js&"
export * from "./oldTreeMsg.vue?vue&type=script&lang=js&"
import style0 from "./oldTreeMsg.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports